"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = exports.Link = exports.Button = exports.TitleContainer = exports.Container = exports.Typography = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
const theme_1 = require("@monorepo/theme");
const core_1 = require("@material-ui/core");
exports.Typography = (0, styled_components_1.default)(core_1.Typography) `
  &.MuiTypography-paragraph {
    margin-bottom: 0;
  }
`;
exports.Container = (0, styled_components_1.default)(core_1.Container) `
  &.MuiContainer-root {
    padding: 16px;
    margin: 0 8px 8px 8px;
  }
  border: 1px solid ${theme_1.colors.grey};
  border-radius: 4px;
`;
exports.TitleContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  gap: 10px;
`;
exports.Button = (0, styled_components_1.default)(core_1.Button).attrs({ disableRipple: true }) `
  &.MuiButton-root {
    text-transform: none;
    border-radius: 18px;
  }

  padding: 0;
`;
exports.Link = styled_components_1.default.a `
  text-decoration: underline;
  cursor: pointer;
`;
exports.Input = (0, styled_components_1.default)(core_1.TextField).attrs(({ type }) => ({
    fullWidth: true,
    variant: 'outlined',
    margin: 'normal',
    required: true,
    type: type || 'text',
})) ``;
